/**
 * Metryki demograficzne z prototypu (rozwijane menu „Dane demograficzne”).
 * Klucze zgodne z kluczami w PARISH_VALUES / DEANERY_AGG / DIOCESE_AGG.
 *
 * Etykiety są w słowniku i18n pod metrics.<klucz>.
 */
export const METRIC_KEYS = [
  'malzenstwa',
  'zgony',
  'urodzenia',
  'przyrost',
  'feminizacja',
  'obciazenie',
  'scholaryzacja',
] as const;

export type MetricKey = (typeof METRIC_KEYS)[number];

export function isMetricKey(value: string): value is MetricKey {
  return (METRIC_KEYS as readonly string[]).includes(value);
}
